import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import "../styles/login.scss";
import { Header, Footer } from "../components-static/Common";
import PropTypes from "prop-types";

export default class PublicPageLayout extends React.Component {
  state = {
    instantiated: false,
  };

  componentDidMount = () => {
    this.setState({
      instantiated: true,
    });
  };

  render() {
    if (!this.state.instantiated) {
      return <div />;
    }

    return (
      <HelmetProvider>
        <div className="page-container" style={this.props.style}>
          <Helmet>
            <title>{this.props.title}</title>
            <meta
              name="viewport"
              content="width=device-width,initial-scale=1"
            />
            <meta
              name="viewport"
              content="height=device-height,initial-scale=1"
            />
          </Helmet>
          <Header type="logo" />
          <div className="public-content" style={this.props.contentStyle}>
            {this.props.children}
          </div>
          <Footer type="half" />

          <div id="tool-tip" className="tool-tip">
            <div id="tool-tip-text" className="tool-tip-text" />
            <div className="tool-tip-triangle" />
          </div>
        </div>
      </HelmetProvider>
    );
  }
}
PublicPageLayout.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string.isRequired,
};
